// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","navCategory":"footer-module--nav-category--c_pix","footerCopyright":"footer-module--footer-copyright--2VnUk"};